import React, { useContext } from 'react';

import { fetchMoreReviewsAction } from 'actions/meshlistReviews';
import styled from 'styled-components';
import { StyledTypography } from 'styles/common';

import MeshListContext from '../MeshListContext';
import { ListItemCSS } from '../styles';

const LoadMoreReviews = ({ employee }) => {
  const { dispatch } = useContext(MeshListContext);
  return (
    <Container>
      <StyledTypography
        onClick={() => dispatch(fetchMoreReviewsAction({ receiverEmployeeId: employee.id }))}
        color="primary"
      >
        Load More
      </StyledTypography>
    </Container>
  );
};

export default LoadMoreReviews;
const Container = styled.div`
  ${ListItemCSS};
`;
